import { RefObject, useEffect, useRef, useState } from 'react';

export function useObservedWidth(
  ref: RefObject<HTMLElement>,
  onSettle?: (width: number) => void,
): number | undefined {
  const [width, setWidth] = useState<number | undefined>(undefined);
  const prevWidthRef = useRef<number | undefined>(undefined);
  const onSettleRef = useRef(onSettle);
  onSettleRef.current = onSettle;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new ResizeObserver((entries) => {
      const newWidth = entries[0]?.contentRect.width;
      if (!newWidth) return;

      setWidth(newWidth);

      if (
        prevWidthRef.current === undefined ||
        newWidth === prevWidthRef.current
      ) {
        onSettleRef.current?.(newWidth);
      }

      prevWidthRef.current = newWidth;
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return width;
}
